<template>
    <div id="error-page" class="flex-center position-ref full-height">
        <div class="content" v-if="!isAuthenticated">
            <h1>404</h1>
            <p>Not Found</p>
            <router-link to="/" class="logo">
                <svg id="logo-icon" data-name="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.17 53.83">
                    <path class="cls-1" d="M60.21,50.77S34,47.78,8.74,53V50.59s31.16-6,54.17-4.56Z" transform="translate(-8.74 -45.42)" />
                    <path class="cls-2" d="M64.56,67.71s-3.9-2.81-3.08-5.25,7.34-15.68,7.34-15.68.45-1.45-.64-1.36-4.35,0-4.35,0a3.94,3.94,0,0,0-2.23,2.33C60.68,49.75,38,94.44,38,94.44s-1.65,2.36,1.39,2.45,24.52-.64,24.52-.64a4,4,0,0,0,2.81-3.17c.27-2.44,1.9-17.48,1.54-18.93a6.09,6.09,0,0,0-3.71-6.44Z" transform="translate(-8.74 -45.42)" />
                    <path class="cls-2" d="M57.13,53H50.78L27.59,99.24h10l1.17-1.9s-1.9.09-3.21,0-.41-1-.41-1l5.59-11,5.06,1.74V85.46L41.41,84,52.23,62.67l4.35,1.5V62.54l-3.64-1.26Z" transform="translate(-8.74 -45.42)" />
                    <path class="cls-1" d="M278.46,71" transform="translate(-8.74 -45.42)" />
                </svg>
            </router-link>
        </div>
        <template v-else>
            <template v-if="loading === false">
                <b-message type="is-danger">The page you are looking for does not exist or you may not have permission to view this. If you believe this is an error please contact us.</b-message>

                <b-message type="is-info">
                    Are you a premium user, trying to login to your dashboard?
                    <a href="/login" v-on:click.prevent="logout"><strong>Click here</strong></a>
                </b-message>

                <div class="error404-wrapper">
                    <div title="404" class="error404">404</div>
                </div>
            </template>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    @import url("//fonts.googleapis.com/css?family=Nunito:200,600");
    @import url('https://fonts.googleapis.com/css?family=Fira+Mono:400');

    #error-page { min-height: 400px; }

    #error-page .content {
        font-family: 'Nunito', sans-serif;
        font-weight: 200;
        color: #ebebeb;
        text-align: center;

        .full-height {
            height: 100vh;
        }

        .flex-center {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        .position-ref {
            position: relative;
        }

        h1 {
            font-size: 30vh;
            margin: 0;
            color: #ebebeb;
        }

        p {
            color: #d6d6d6;
            font-size: 3vh;
            font-weight: 700;
            position: relative;
            margin: -30px 0 0 0;
            text-transform: uppercase;
            letter-spacing: .02em;
        }

        .logo {
            width: 50px;
            text-align: center;
            margin: 60px auto;
            opacity: .2;
            text-decoration: none;
            color: #fff;
            display: block;
            transition: all .2s ease;
        }

        .logo:hover {
            opacity: 1;
        }

        .cls-1 { fill: #F5F5F5 }
        .cls-2 { fill: #FFFFFF }

        @-webkit-keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }

        @-moz-keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }

        @keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }
    }

    .error404-wrapper {
        margin-top: 30%;
        margin-bottom: 30%;
        margin-left: calc(50% - 160px / 2);
    }

    .error404 {
        width: 160px;
        align-items: center;
        justify-content: center;
        margin: 0;
        font-size: 96px;
        font-family: 'Fira Mono', monospace;
        color: #bababa;
        letter-spacing: -6px;
    }

    .error404 {
        animation: glitch 4s linear infinite;
    }

    @keyframes glitch{
        2%,64%{
            transform: translate(2px,0) skew(0deg);
        }
        4%,60%{
            transform: translate(-2px,0) skew(0deg);
        }
        62%{
            transform: translate(0,0) skew(5deg);
        }
    }

    .error404:before,
    .error404:after{
        content: attr(title);
        position: absolute;
        left: 0;
    }

    .error404:before{
        animation: glitchTop 4s linear infinite;
        clip-path: polygon(0 0, 100% 0, 100% 33%, 0 33%);
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 33%, 0 33%);
    }

    @keyframes glitchTop{
        2%,64%{
            transform: translate(4px,-2px);
        }
        4%,60%{
            transform: translate(-1px,0);
        }
        62%{
            transform: translate(13px,-1px) skew(-13deg);
        }
    }

    .error404 :after{
        animation: glitchBotom 4.5s linear infinite;
        clip-path: polygon(0 67%, 100% 67%, 100% 100%, 0 100%);
        -webkit-clip-path: polygon(0 67%, 100% 67%, 100% 100%, 0 100%);
    }

    @keyframes glitchBotom{
        2%,64%{
            transform: translate(-2px,0);
        }
        4%,60%{
            transform: translate(-2px,0);
        }
        62%{
            transform: translate(-22px,5px) skew(21deg);
        }
    }
</style>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '../../store/actions/auth'
export default {
  name: 'PageNotFound',
  props: {
    //
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated'
    }),
    ...mapState({
      loading: 'loading'
    })
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    logout: function () {
      if (this.pusher) {
        this.pusher.allChannels()
          .forEach(channel => this.pusher.unsubscribe(channel.name))
      }

      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({ name: 'login' })
    }
  },
  mounted () {
    this.setPageTitle('Oops!')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error/404.vue